import React, { Fragment, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button }from '@cmsgov/design-system';


import Table from '../../common/table/Table';

const SeeksQHP = (props) => {

    const { collapsed, seeksQHP, disableSaveChangesBtn, onSaveChangesCb, additionalNote=false, exchangeName } = props;
    const [seeksQHPCollapsed, setSeeksQHP] = useState(collapsed);

    return seeksQHP && seeksQHP.data && seeksQHP.data.length > 0 && (
        <div className="seeks-QHP gi-panel">
            <h3 className='seeks-QHP__toggle' onClick={() => setSeeksQHP(!seeksQHPCollapsed)}>
                <FormattedMessage id="eligibility_results.seeksQHP.header" />
                <FontAwesomeIcon icon={seeksQHPCollapsed ? 'chevron-down' : 'chevron-up'} className="grid-col-1 icon"/>
            </h3>

            {!seeksQHPCollapsed &&
                <Fragment>
                    <p className='seeks-QHP__note'>
                        <FormattedMessage id="eligibility_results.seeksQHP.p1" values={{ lineBreak: <br/>, exchangeName, br: <br/> }}/>
                    </p>
                    { additionalNote &&
                        <p className='seeks-QHP__note'>
                            <FormattedMessage id="eligibility_results.seeksQHP.p2"/>
                        </p>
                    }
                    <Table data={seeksQHP.data} columns={seeksQHP.columns}/>
                    <Button
                        id='eligibilitySave'
                        className='usa-button usa-button--outline gi-button gi-button__outline eligibility_CTA'
                        disabled={disableSaveChangesBtn}
                        onClick={onSaveChangesCb}
                    >
                        <FormattedMessage id='button.save_changes'/>
                    </Button>
                </Fragment>
            }
        </div>
    );
};

export default SeeksQHP;